import { Countries } from 'typings'
import getConstants from '../../constants'
import { reqError, isReqError } from '../Request/error'

export type GetStatesForRegionProps = {
  country: string
}

type clientID = {
  [country: string]: string
}

// This config is temporary for now. Will be shifted to config files after confirmation
// using SPA values right now cause SL client IDs are not supported.
export const countryClientID: clientID = {
  [Countries.JP]: 'uq.jp.web-spa',
  [Countries.US]: 'uq.us.web-spa',
  [Countries.KR]: 'uq.kr.web-spa',
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''
const CONSTANTS = getConstants()

export const getCMSResponse = async (country: string) => {
  const response = await fetch(
    `${API_BASE_URL}/${CONSTANTS.COUNTRY}/api/storelocator/v1/${CONSTANTS.LANGUAGE}/cms?path=/storelocator/top/`,
    { headers: { 'x-fr-clientID': countryClientID[CONSTANTS.COUNTRY] } },
  )
  const { status: statusCode } = response
  const json = await response.json()

  if (isReqError(statusCode)) {
    throw reqError(statusCode, json.message)
  }

  return json
}
